export default __webpack_public_path__ + "static/media/hht1_ani_09.0da7bab8.png";